declare const __API_BASE_URL__: string;

export function getApiBaseUrl(): string {
  return __API_BASE_URL__ || "";
}

export function buildApiUrl(path: string): string {
  return `${getApiBaseUrl()}${path}`;
}

export const config = {
  api: {
    baseUrl: __API_BASE_URL__,
  },
};
